module.exports = __webpack_public_path__ + "img/PM_A02_front_diagonal_en.53afa4ad.png";